import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <React.Fragment>
    <g id="google-dogfood-admin-logo">
      <rect id="Rectangle" fill="#3BAB59" x="7" y="19" width="10" height="5" />
      <path d="M22,17 L22,23.9963616 L17,23.9900822 C17,18.6609351 17,15.3296949 17,13.9963616 C17,12.7235185 16.6962257,11.755555 16.0886772,11.092471 C16.0587979,11.0625413 16.0292388,11.0329304 16,11.0036384 C14.6666667,9.66787948 13.3333333,9 12,9 L16.5,4.5 L24,12 L24,17 L22,17 Z" id="Combined-Shape" fill="#4385F7" />
      <path d="M2,17 L8,11.0036384 C7.33333333,11.6678795 7,12.6666667 7,14 C7,15.3333333 7,18.6645736 7,23.9937207 L2,24 L2,17 Z" id="Rectangle" fill="#FDC00D" />
      <path d="M-4.00529581e-15,12 L12,0 L16.5,4.5 L12,9 C10.6666667,9 9.33333333,9.66787948 8,11.0036384 C6.66666667,12.3393974 4.66666667,14.3381846 2,17 L-7.99655631e-08,17.0000001 L-4.00529581e-15,12 Z" id="Rectangle" fill="#EC5043" />
    </g>
  </React.Fragment>
  , 'DogfoodAdminLogo');
